import { Item } from "../../pojo/Item";
import { S25ItemI } from "../../pojo/S25ItemI";

export interface OccurrenceScheduleRow {
    occId: number;
    startDt: Date;
    endDt: Date;
}

export interface OccurrenceScheduleObject {
    itemId: number;
    itemTypeId: Item.Ids.Location | Item.Ids.Resource;
    itemName?: string;
    quantity?: number;
}

export interface OccurrenceScheduleAssignment {
    occId: number;
    objects: OccurrenceScheduleObject[];
}

export interface OccurrenceScheduleValue {
    profileCode: string;
    occurrences: OccurrenceScheduleRow[];
    objectsForAllOccurrences: OccurrenceScheduleObject[];
    assignments: OccurrenceScheduleAssignment[];
}

export type OccurrenceScheduleObjectKind = "locations" | "resources";

export interface OccurrenceScheduleConfig {
    objectKinds: OccurrenceScheduleObjectKind[];
    showAllOccurrencesPicker: boolean;
    showPerOccurrenceRows: boolean;
}

export interface OccurrenceScheduleDatesChangeContext {
    trigger: "startChange" | "endChange" | "patternChange";
    profileCode: string;
    previous: OccurrenceScheduleRow[];
    current: OccurrenceScheduleRow[];
}

export interface OccurrenceScheduleObjectChangeContext {
    scope: "allOccurrences" | "occurrence";
    occId?: number;
    action: "add" | "remove" | "replace";
    object: OccurrenceScheduleObject;
    value: OccurrenceScheduleValue;
}

export const DEFAULT_OCCURRENCE_SCHEDULE_CONFIG: OccurrenceScheduleConfig = {
    objectKinds: ["locations"],
    showAllOccurrencesPicker: true,
    showPerOccurrenceRows: true,
};

export type OccurrenceScheduleObjectChangeHandler = (
    context: OccurrenceScheduleObjectChangeContext,
) => void | Promise<void>;

export type OccurrenceScheduleDatesChangeHandler = (
    context: OccurrenceScheduleDatesChangeContext,
) => void | Promise<void>;

export function scheduleObjectFromItem(
    item: S25ItemI,
    itemTypeId: Item.Ids.Location | Item.Ids.Resource,
): OccurrenceScheduleObject {
    return {
        itemId: Number(item.itemId),
        itemTypeId,
        itemName: item.itemName,
    };
}

export function scheduleItemFromObject(object: OccurrenceScheduleObject): S25ItemI {
    return {
        itemId: object.itemId,
        itemTypeId: object.itemTypeId,
        itemName: object.itemName,
    };
}
